module.exports = __webpack_public_path__ + "img/screen-dashboard-circle.246ad233.png";